<template>
  <ca-modal
    ref="reportCenterModal"
    :title="report.name">
    <report-center-modal-filters
      :filters="filters"
      :options="report.options"
      @update="setFilters"
      @intern-id="setInternId"
      @is-intern="handlerSubmitButtonDisableStatus" />
    <ca-row slot="footer" class="ca-u-justify-content--space-between">
      <ca-col size="2">
        <ca-button full-width @click="onClose">
          Fechar
        </ca-button>
      </ca-col>
      <ca-col :size="generateButtonsSize">
        <div class="ca-u-flex">
          <ca-dropdown
            v-if="shouldShowOtherFormatsButton"
            title="Outros Formatos"
            :disabled="shouldDisableButton">
            <ca-dropdown-item
              v-for="dropdownItemOption in dropdownItemOptions"
              :key="dropdownItemOption.value"
              @click="generateReport(dropdownItemOption.value)">
              {{ dropdownItemOption.label }}
            </ca-dropdown-item>
          </ca-dropdown>
          <ca-request-button
            :on-request="generatePdfReport"
            :on-request-success="onClose"
            :on-request-error="handleError"
            :disabled="shouldDisableButton"
            class="ca-u-margin-left"
            theme="primary">
            Gerar PDF
          </ca-request-button>
        </div>
      </ca-col>
    </ca-row>
  </ca-modal>
</template>

<script>
import {
  getReport,
  mapRequestFilters,
  getProvisionReport,
  mapRequestProvisionFilters,
} from './reportCenterModalService';
import {
  PROVISION_REPORTS,
  DROPDOWN_ITEM_OPTIONS,
  CURRENT_DATE_BRAZILIAN,
  CURRENT_DATE_AMERICAN,
  CURRENT_YEAR,
  SELECT_ALL_OPTION,
  RADIO_ESTABLISHMENT_OPTION,
  RADIO_REGISTER_OPTION,
  REPORTS,
} from './constants';
import ReportCenterModalFilters from './components/report-center-modal-filters/ReportCenterModalFilters.vue';
import { clickGenerateReportTracker } from './reportCenterModalTrackerService';

export default {
  name: 'ReportCenterModal',
  components: {
    ReportCenterModalFilters,
  },
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filters: {
        stocking: SELECT_ALL_OPTION,
        jobDescription: SELECT_ALL_OPTION,
        worker: SELECT_ALL_OPTION,
        dateMonthPeriod: CURRENT_DATE_BRAZILIAN(),
        dateYearPeriod: CURRENT_YEAR(),
        description: null,
        datePeriod: CURRENT_DATE_AMERICAN(),
        event: SELECT_ALL_OPTION,
        orderBy: RADIO_REGISTER_OPTION,
        groupBy: RADIO_ESTABLISHMENT_OPTION,
      },
      isIntern: null,
      internId: null,
    };
  },
  computed: {
    dropdownItemOptions() {
      return DROPDOWN_ITEM_OPTIONS;
    },
    shouldDisableButton() {
      return this.isIntern && !this.internId;
    },
    shouldShowOtherFormatsButton() {
      return !this.report?.options?.hideOtherOptionsButton;
    },
    generateButtonsSize() {
      return this.shouldShowOtherFormatsButton ? 4 : 2;
    },
  },
  methods: {
    setFilters(filters) {
      this.filters = filters;
    },
    onClose() {
      this.$refs.reportCenterModal.close();
    },
    generatePdfReport() {
      return this.generateReport('pdf');
    },
    generateReport(reportType) {
      const report = this.report.value;
      const reportName = this.report.name;

      const reportMapper = this.getReportMapper(report);

      if (reportMapper !== undefined) {
        const requestBody = {
          type: report,
          format: 'PDF',
          competence: this.filters.dateMonthPeriod,
        };

        return reportMapper.endpoint(requestBody);
      }

      const filters = {
        ...this.filters,
        report,
        reportName,
        reportType,
      };

      const mappedRequestFilters = PROVISION_REPORTS.includes(report)
        ? mapRequestProvisionFilters(filters)
        : mapRequestFilters(filters);

      if (this.internId) {
        mappedRequestFilters.idFuncionario = this.internId;
      }

      clickGenerateReportTracker({ name: reportName, type: reportType });

      return PROVISION_REPORTS.includes(report)
        ? getProvisionReport(mappedRequestFilters)
        : getReport(mappedRequestFilters);
    },
    getReportMapper(report) {
      return REPORTS.find(r => r.reports.includes(report));
    },
    handleError() {
      this.$toaster.error({
        title: 'Conexão Interrompida',
        content: 'O relatório não foi gerado pois houve um problema na conexão, tente novamente.',
      });
    },
    setInternId(id) {
      this.internId = id;
    },
    handlerSubmitButtonDisableStatus(status) {
      this.isIntern = status;
    },
  },
};
</script>
